const da = {
  layout: {
    cos_button: {
      phone: 'Telefon',
      update_phone_number_message: 'Telefonnummeret blev opdateret!'
    },
    time: {
      days: 'Dage',
      hours: 'Timer',
      mins: 'Min',
      secs: 'Sek',
      starts: 'Starter',
      starts_immediately: 'Starter med det samme'
    },
    field: {
      host: 'Vært'
    },
    copy: 'Kopier'
  },
  validations: {
    email: 'skal være en gyldig email',
    phone: 'skal være et gyldigt telefonnummer',
    required_field: 'er et obligatorisk felt'
  },
  mailer: {
    need_help: 'Brug for hjælp?',
    stop_reminders: 'Stop med at modtage påmindelser',
    cancel_registration: 'Aflys registrering',
    report_abuse: 'Rapporter misbrug'
  },
  datetime: {
    no_sessions: 'Ingen tilgængelige sessioner',
    empty_label: 'Dato/tid'
  },
  errors: {
    verification_failed: 'Verificeringen mislykkedes. Prøv venligst igen.',
    session_unavailable: 'Det tidspunkt, du har valgt, er ikke længere tilgængeligt. Vælg venligst et andet tidspunkt.',
    challenge_email_mismatch: 'Tilmeld dig med den samme e-mail, som du brugte til at tilmelde dig begivenheden.'
  }
}

export default da
